import React, { useGlobal } from 'reactn';
import useUnleashClientHook from '../../../../v2/core/unleash/withUnleashClient/useUnleashClientHook';
import { UnleashService } from '../../../../v2/services';

const ManageStaff = React.lazy(() => import("../manage-staff"));
const ManageStaffV2 = React.lazy(() => import("../manage-staff-v2"));

export const ManageStaffContainer = (props) => {
    const [global] = useGlobal();
    const { getClient } = useUnleashClientHook();
    const createStaffV2Enabled = getClient().isEnabled(UnleashService.FLAGS.CREATE_STAFF_V2);

    if (global.cbacConfigFlag) {
        return <ManageStaffV2 {...props} createStaffV2Enabled={createStaffV2Enabled} />;
    }

    return <ManageStaff {...props} />;
};


export default ManageStaffContainer;